var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-video",domProps:{"innerHTML":_vm._s(_vm.youtubeIframeCode)}})
}
var staticRenderFns = []

export { render, staticRenderFns }